export const USER_VISIT = 'User Visit';
export const PAGE_VISIT = 'Page Visit';
